<!-- <div class="col-sm-12" style="height: 100%" (click)="common.outSide($event)"> -->
<div class="col-sm-12" *ngIf="!isEmpty" style="height: 100%">
  <app-detail-devis [devis]="detailDevis" [codeExterne]="codeExterne" [client]="client" [add]="detailDevis.id ? false : true" [openId]="true" (ficheclient)="showFiche()"
    (hidefunction)="closeAndOpen()"></app-detail-devis>
</div>
<app-empty-detail-devis *ngIf="isEmpty"></app-empty-detail-devis>

<div class="fiche" #fiche id="fiche" [ngStyle]="{'width': showFicheclt ? '100%' : '0'}">
  <div class="col-sm-12 client" *ngIf="showFicheclt">
    <app-fiche-client [client]="client.id || 0" [objClient]="client || {}" (hidefunction)="showFiche()"
      [add]="addClient" [prospect]="true"></app-fiche-client>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg"> {{ error }} </label>
          </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
          <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer </button>
      </div>
  </div>
</ng-template>

<ng-template #document>
  <div class="modal-body" style="height: auto">
      <div class="col-sm-12">
          <app-gestion-document [data]="common.listDoc" (hidefunction)="common.closeModal()"></app-gestion-document>
      </div>
  </div>
</ng-template>